import { Text } from '@mantine/core';

export const DetailInfoText = ({ children }: { children: React.ReactNode }) => (
	<Text size="lg" fw={600}>
		{children}
	</Text>
);
